import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class DalService {

  constructor(
    public ls: LocalStorageService,
    public ds: DataService,
  ) { }

  getVolumeLeaderData() {
    return new Promise((resolve, reject) => {
      this.ds.FetchVolumeLeaderData().then((res) => {
        this.ls.setObject("VolLeaders", res);
        return resolve(true);
      },
        (error) => {
          console.log("Error fetching Volume Leaders");
          return resolve(false);
        });
    });
  }

  getTopGainerData() {
    return new Promise((resolve, reject) => {
      this.ds.FetchTopGainerData().then((res) => {
        this.ls.setObject("TopGainers", res);
        return resolve(true);
      },
        (error) => {
          console.log("Error fetching Top Gainers");
          return resolve(false);
        });
    });
  }

  getTopLoserData() {
    return new Promise((resolve, reject) => {
      this.ds.FetchTopLoserData().then((res) => {
        this.ls.setObject("TopLosers", res);
        return resolve(true);
      },
        (error) => {
          console.log("Error fetching Top Losers");
          return resolve(false);
        });
    });
  }

  getIndexData() {
    return new Promise((resolve, reject) => {
      this.ds.FetchIndexData().then((res) => {
        this.ls.setObject("Indexes", res);
        return resolve(true);
      },
        (error) => {
          console.log("Error fetching Indexes");
          return resolve(false);
        });
    });
  }

  getTickerData() {
    return new Promise((resolve, reject) => {
      this.ds.FetchTickerData().then((res) => {
        this.ls.setObject("Tickers", res);
        return resolve(true);
      },
        (error) => {
          console.log("Error fetching Tickers");
          return resolve(false);
        });
    });
  }

  // /* #region Agent  */
  // AgentSignUp(data) {
  //   return new Promise((resolve, reject) => {
  //     this.ads.SignUpService(data).then((res) => {
  //       this.ls.setObject("AgentProfile", res);
  //       return resolve(res);
  //     },
  //       (error) => {
  //         console.log(error);
  //         return resolve(false);
  //       });
  //   });
  // }

  // hasAgentData() {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.ls.getObject("AgentProfile").then((res) => {
  //         if (res == null) {
  //           return resolve(false);
  //         }
  //         else {
  //           return resolve(true);
  //         }
  //       },
  //         (error) => {
  //           console.log(error);
  //           return reject(false);
  //         });
  //     } catch (error) {
  //       console.log(error);
  //       return resolve(false);
  //     }
  //   });
  // }

  // isAgentLogin() {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.getAgentData().then((res: any) => {
  //         if (res != null) {
  //           if (res.isSignIn) {
  //             return resolve(true);
  //           }
  //           else {
  //             return resolve(false);
  //           }
  //         }
  //         else {
  //           return resolve(false);
  //         }
  //       });
  //     } catch (error) {
  //       console.log(error);
  //       return resolve(false);
  //     }
  //   });
  // }

  // getAgentData() {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.ls.getObject("AgentProfile").then((res) => {
  //         return resolve(res);
  //       });
  //     } catch (error) {
  //       console.log(error);
  //       return resolve(null);
  //     }
  //   });
  // }

  // AgentSignIn(data) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.ads.SignInService(data).then((res: any) => {
  //         if (res != null) {
  //           if (res.agentID > 0) {
  //             this.ls.clear();
  //             this.ls.setObject("AgentProfile", res);
  //             return resolve(true);
  //           }
  //           else {
  //             return resolve(false);
  //           }
  //         }
  //         else {
  //           return resolve(false);
  //         }
  //       });
  //     } catch (error) {
  //       console.log(error);
  //       return resolve(false);
  //     }
  //   });
  // }

  // updateAgentData(data) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.ads.updateAgentProfile(data).then((res: boolean) => {
  //         if (res) {
  //           this.ls.setObject("AgentProfile", data);
  //           return resolve(true);
  //         }
  //         else {
  //           return resolve(false);
  //         }
  //       });
  //     } catch (error) {
  //       console.log(error);
  //       return resolve(false);
  //     }
  //   });
  // }

  // createBlankAgent() {
  //   return new Promise((resolve, reject) => {
  //     this.ls.setObject("AgentProfile", {});
  //     return resolve(true);
  //   });
  // }
  // /* #endregion */

  // /* #region Properties  */
  // getProperties(agentID) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.pds.getPropList(agentID).then((res) => {
  //         if (res != null) {
  //           this.ls.setObject("PropertyList", res);
  //           return resolve(res);
  //         }
  //         else {
  //           return resolve([]);
  //         }
  //       });
  //     } catch (error) {
  //       console.log(error);
  //       return resolve([]);
  //     }
  //   });
  // }

  // updateProperty(property: any) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.ls.getObject("PropertyList").then((res2: any) => {
  //         let index = res2.findIndex((prop) => prop.propID == property.propID);
  //         res2[index] = property;
  //         this.ls.setObject("PropertyList", res2);
  //       });
  //       this.pds.updateProperty(property).then((res: boolean) => {
  //         return resolve(res);
  //       });
  //     } catch (error) {
  //       console.log(error);
  //       return resolve(false);
  //     }
  //   });
  // }
  // /* #endregion */

  // /* #region  Offers */
  // getOffers(agentID) {
  //   return new Promise((resolve, reject) => {
  //     try {
  //       this.ods.getOfferList(agentID).then((res) => {
  //         if (res != null) {
  //           this.ls.setObject("OfferList", res);
  //           return resolve(res);
  //         }
  //         else {
  //           return resolve([]);
  //         }
  //       });
  //     }
  //     catch (error) {
  //       console.log(error);
  //       return resolve([]);
  //     }
  //   });
  // }
  // /* #endregion */
}
